import axios from '../axiosClient';
export const getShareholders = (societyId) => axios.get('/postinvest/shareholders/', { params: { societyId } });
export const getOperationById = (societyId, operationsId) => axios.get(`/postinvest/operations/details/${operationsId}`, { params: { societyId } });
